export enum PlannerTaskRelationType {
  FEEDBACK = 'Feedback',
  DASHBOARD_WIDGET = 'DashboardWidget',
  LEO_SUGGESTION = 'LeoSuggestion',
  CUSTOMER_JOURNEY_MAP_TILE = 'CustomerJourneyMapTile',
  // A channel; the API does not accept it yet.
  NODE = 'Node',
}
